export { default } from './ClassNameGenerator';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/ClassNameGenerator/index.js
// module id = 439
// module chunks = 25